<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Career - Create Job</CCardHeader>
        <CCardBody>
          <CRow>
            <CCol :col="6">
              <CSelect 
                label="Negara"
                :options="optionCountry"
                vertical
                @input="handleCountry"
                placeholder="Select Negara"
                v-model="careerData.country"
              />
            </CCol>
            <CCol :col="6">
              <LocationSearch
                  v-model="careerData.city"
                  :options="optionLocation"
                  :loading="loadingLocation"
                  label="Lokasi"
                  @search="searchDistrict"
                  @selected="handleSelectedLocation"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CSelect
                label="Divisi"
                :options="optionEmploymentDivision"
                vertical
                @input="handleEmploymentDivision"
                placeholder="Select Divisi"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Posisi"
                class="mb-0"
                v-model="careerData.job_position"
                vertical
                placeholder="Posisi"
              />
            </CCol>
            <CCol :col="6">
              <CSelect
                label="Job Level"
                :options="optionJobLevel"
                vertical
                @input="handleJobLevel"
                placeholder="Select Job Level"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CSelect
                label="Employment Type"
                :options="optionEmploymentGroup"
                vertical
                @input="handleEmploymentType"
                placeholder="Employment Group"
              />
            </CCol>
            <CCol :col="6">
              <CSelect
                label="Employment Status"
                :options="optionEmploymentStatus"
                vertical
                @input="handleEmploymentStatus"
                placeholder="Employment Status"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6" >
              <CTextarea
                label="Meta Description"
                class="mb-0"
                type="text"
                vertical
                v-model="careerData.meta_info_description"
                placeholder="Meta Description"
              />
            </CCol>
            <CCol :col="6" >
              <CTextarea
                label="Meta Keyword"
                class="mb-0"
                type="text"
                vertical
                v-model="careerData.meta_info_keyword"
                placeholder="Meta Keyword"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Minimum Experience (Years)"
                type="number"
                vertical
                min="0"
                v-model.number="careerData.minimum_experience"
                placeholder="Enter Minimum Experience"
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Required Candidate"
                type="number"
                vertical
                min="0"
                v-model.number="careerData.required_candidates"
                placeholder="Enter Required Candidate"
              />
            </CCol>
          </CRow>

          <CRow class="form-group">
            <CCol
              :col="6"
              v-if="careerData.employment_type === 'Walk-in Interview'"
            >
              <CInput
                label="Quota"
                class="mb-0"
                type="number"
                v-model="careerData.quota"
                vertical
                min="0"
                placeholder="Quota"
              />
            </CCol>
          </CRow>
          <CRow
            class="form-group"
            v-if="careerData.employment_type === 'Walk-in-Interview'"
          >
            <CCol :col="6">
              <CInput
                label="Tempat Acara"
                class="mb-0"
                v-model="careerData.place"
                vertical
                placeholder="Tempat Acara"
              ></CInput>
            </CCol>
          </CRow>
          <CRow
            class="form-group"
            v-if="careerData.employment_type === 'Walk-in Interview'"
          >
            <CCol :col="6">
              <CInput
                label="Tanggal"
                class="mb-0"
                type="date"
                v-model="date"
                vertical
                placeholder="Tanggal"
                @input="handleDateChange"
              />
            </CCol>
            <CCol
              :col="6"
              v-if="careerData.employment_type === 'Walk-in Interview'"
            >
              <CInput
                label="waktu"
                class="mb-0"
                type="text"
                v-model="time"
                placeholder="00:00"
                @input="handleTimeChange"
              />
            </CCol>
          </CRow>
          <CRow
            class="form-group"
            v-if="careerData.employment_type === 'Walk-in Interview'"
          >
            <CCol :col="12">
              <p>Harus Membawa</p>
              <vue-editor
                class="mt-2"
                v-model="content3"
                :editor-toolbar="customToolbar"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="12">
              <p>Job Description</p>
              <vue-editor
                class="mt-2"
                v-model="content"
                :editor-toolbar="customToolbar"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="12">
              <p>Minimum Qualifications</p>
              <vue-editor
                class="mt-2"
                v-model="content2"
                :editor-toolbar="customToolbar"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="12">
              <label class="mb-2 font-weight-bold">Required Skills</label>
              <BadgeInput
                  v-model="careerData.required_skills"
                  placeholder="Add skill and press Enter"
                  badge-color="light"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="3">
              <CSelect
                label="Status"
                :options="optionStatus"
                vertical
                @input="handleStatus"
                placeholder="Pilih"
              />
            </CCol>
            <CCol :col="3">
              <CInput
                  label="Priority"
                  type="number"
                  min="1"
                  vertical
                  v-model="careerData.priority"
                  placeholder="Priority"
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton color="success" class="float-right" @click="createCareer"
                >Submit</CButton
              >
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import jwt from "jsonwebtoken";
import moment from "moment";
import { VueEditor } from "vue2-editor";
import DivisionUseCase from '../app/usecase/division';
import BadgeInput from "@/components/BadgeInput.vue";
import LocationSearch from "@/components/LocationSearch.vue";

export default {
  components: {BadgeInput, VueEditor , LocationSearch},
  name: "JobCreate",

  data() {
    return {
      careerData: {
        division_id: 0,
        job_position: "",
        job_level: "",
        employment_type: "",
        employment_status: "",
        job_description: "",
        min_qualification: "",
        place: "",
        datetime_event: "",
        note: "",
        quota: 0,
        city: "",
        status: "",
        location_city: "",
        meta_info_description: "",
        meta_info_keyword: "",
        minimum_experience: 0,
        required_candidates: 0,
        required_skills: [],
        priority: "",
        country: "indonesia"
      },
      content: "",
      content2: "",
      content3: "",
      customToolbar: [
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [{ size: ["small", false, "large", "huge"] }],
        ["bold", "italic", "underline", "strike"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        [{ header: 1 }, { header: 2 }],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ direction: "rtl" }],
        ["clean"],
      ],
      date: "",
      time: "",
      typeE: "",
      optionEmploymentDivision: [],
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      optionLocation: [],
      countryCode: "id",
      loadingLocation: false,
      optionJobLevel: ["Director", "Chief", "VP", "AVP", "Head", "Manager", "Assistant Manager", "Supervisor", "Lead", "Staff", "Intern"],
      optionEmploymentGroup: ["Undangan", "Walk-in Interview"],
      optionEmploymentStatus: ["Full Time","Contract", "Part Time", "Intern"],
      optionStatus: ["ACTIVE", "INACTIVE"],
      optionCountry: [
        {value: "indonesia", label: "Indonesia"}, 
        {value: "malaysia", label: "Malaysia"}
      ],
    };
  },
  mounted() {
    this.authentication();
    this.getLocation();
    this.getDivision();
  },
  computed: {
    eventDateTime() {
      return moment(this.date + " " + this.time).format();
    }
  },
  methods: {
    async getDivision() {
      try {
        const { data, err } = await DivisionUseCase.getAll("page=1&per_page=100&status=ACTIVE");
        if (err || data.data.length == 0) {
          this.err = err;
        } else {
          if (data) {
            this.optionEmploymentDivision = data.data.map(a => {
              return {
                value: a.division_id,
                label: a.division_name
              }
            }).sort((a, b) => a.label.localeCompare(b.label))
          }
        }
      }
      catch (err) {
        await this.$swal.fire({
          icon: "error",
          text: err,
        });
      }
    },
    getLocation(country = "indonesia") {
      this.optionLocation = [];
      this.careerData.city = "";

      this.countryCode = country === "malaysia" ? "my" : "id";
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "HRD" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    goBack() {
      this.usersOpened
        ? this.$router.go(-1)
        : this.$router.push({ path: "/career/job" });
    },

    handleLocation(event) {
      this.careerData.city = event.target.value;
    },
    handleJobLevel(event) {
      this.careerData.job_level = event.target.value;
    },
    handleEmploymentType(event) {
      this.careerData.employment_type = event.target.value;
      this.type = event.target.value;
    },
    handleEmploymentStatus(event) {
      this.careerData.employment_status = event.target.value;
    },
    handleStatus(event) {
      this.careerData.status = event.target.value;
    },
    handleEmploymentDivision(event) {
      this.careerData.division_id = event.target.value;
    },
    handleSelectedLocation(item) {
      this.careerData.location_city = item.label;
    },
    handleDateChange(date) {
      this.date = date;
    },
    handleTimeChange(time) {
      this.time = time;
    },
    handleCountry(event) {
      const selectedCountry = event.target.value.toLowerCase();

      this.careerData.country = selectedCountry;
      this.careerData.city = "";
      this.careerData.location_city = "";

      this.getLocation(selectedCountry);


      const countryMap = {
        malaysia: "my",
        indonesia: "id",
      };

      this.countryCode = countryMap[selectedCountry] || "id";
    },
    async searchDistrict(keyword) {
      if (!keyword || keyword.length < 3) {
        return;
      }
      this.loadingLocation = true;
      try {
        const res = await axios.get(
            `${this.domain}/v1/location/district/data`,
            {
              params: {
                page: 1,
                per_page: 100,
                search: keyword,
                country_code: this.countryCode
              },
              headers: {
                Authorization: this.token,
              },
            }
        );

        this.optionLocation = res.data.data.map(a => ({
          value: a.district_name,
          label: a.district_name
        }));

      } catch (err) {
        console.log(err);
      }finally {
        this.loadingLocation = false;
      }

    },
    createCareer() {
      if (this.careerData.minimum_experience < 0 || this.careerData.required_candidates < 0) {
        Swal.fire({
          icon: "error",
          title: "Validation Error",
          text: "Minimum Experience and Required Candidate cannot be less than 0"
        });
        return;
      }

      if (
          this.careerData.priority === "" ||
          this.careerData.priority === null ||
          this.careerData.priority === undefined
      ) {
        delete this.careerData.priority;
      } else {
        const priority = Number(this.careerData.priority);

        if (priority <= 0) {
          Swal.fire({
            icon: "error",
            title: "Validation Error",
            text: "Priority must be greater than 0",
          });
          return;
        }

        this.careerData.priority = priority;
      }

      var today = new Date();
      var dateEventNew = moment(today).format();
      this.careerData.quota = Number(this.careerData.quota);
      this.careerData.division_id = Number(this.careerData.division_id);
      console.log("dateEvent", this.eventDateTime);
      if (this.careerData.employment_type !== "Walk-in Interview") {
        this.careerData.datetime_event = dateEventNew;
      } else {
        this.careerData.datetime_event = this.eventDateTime;
      }
      this.careerData.job_description = this.content;
      this.careerData.min_qualification = this.content2;
      this.careerData.note = this.content3;

      axios
        .post(`${this.domain}/v1/career`, this.careerData, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          Swal.fire({
            icon: "success",
            title: `Job Created`,
            showConfirmButton: false,
            timer: 2000,
          });
          this.items = response.data;
          this.$router.push({ path: `/career/job` });
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: err.response.data.message.id,
          });
        });
    },
  },
};
</script>

<style scoped>
@import "./Job.css";
</style>
